var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isProd)?_c('div',{staticClass:"text-center bg-green text-bold text-orange envBanner"},[_vm._v("\n  "+_vm._s(_vm.environment)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }